import React, { useState, useEffect } from "react";
import logger from "../../../utils/logger.ts";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "bootstrap/js/dist/collapse";

import SecondaryButton from "components/Button/SecondaryButton";
import { useQuery } from "utils/useQuery";

import {
  EXPAND,
  GANGSTA_BET_11,
  GANGSTA_HEAD,
  SUIT,
  SHOES,
  ClOSE,
  SEARCH_ICON,
  CLASS_TYPE_ICON,
  ICON_PLUS,
} from "src/constants/images";
import { MARKET_PLACE } from "src/constants/routes";
import { isEmpty } from "utils/isEmpty";
import {
  fetchMarketPlaceFilterData,
  fetchMarketPlaceQuery,
  fetchMarketPlaceData,
  setCurrentPage,
  fetchMarketPlaceSearchData,
} from "../../../redux/actions/marketplace";
import FilterItem from "./FilterItem/FilterItem";

const Filter = ({
  hide,
  handleClose,
  filterData,
  setPageIndex,
  optionRemoveHandler,
}) => {
  const [collapse, setCollapse] = useState({
    type: false,
    class: false,
    sale: false,
    level: false,
    search: false,
    vAttributes: false,
  });

  const navigate = useNavigate();
  const queryPath = useQuery();
  const dispatch = useDispatch();

  const [activeType, setActiveType] = useState("");
  const [classType, setClassType] = useState("");
  const [levelType, setLevelType] = useState("");
  const [tokenName, setTokenName] = useState("");
  const [tokenNumber, setTokenNumber] = useState("");

  const [visualAttribute, setVisualAttribute] = useState([]);
  const [forSale, setForSale] = useState("");

  const { query, currentPage } = useSelector((state) => state.marketplace);

  const handleCollapse = (value) => {
    switch (value) {
      case "class":
        if (!collapse.class) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                class: !prev.class,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              class: !prev.class,
            };
          });
        }
        break;

      case "sale":
        if (!collapse.sale) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                sale: !prev.sale,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              sale: !prev.sale,
            };
          });
        }
        break;

      case "type":
        if (!collapse.type) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                type: !prev.type,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              type: !prev.type,
            };
          });
        }
        break;

      case "level":
        if (!collapse.level) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                level: !prev.level,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              level: !prev.level,
            };
          });
        }
        break;
      case "visual-attribute":
        if (!collapse.vAttributes) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                vAttributes: !prev.vAttributes,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              vAttributes: !prev.vAttributes,
            };
          });
        }
        break;
      case "search":
        if (!collapse.search) {
          setTimeout(() => {
            setCollapse((prev) => {
              return {
                ...prev,
                search: !prev.search,
              };
            });
          }, 300);
        } else {
          setCollapse((prev) => {
            return {
              ...prev,
              search: !prev.search,
            };
          });
        }

      default:
    }
  };

  const { types, class_types, status, level, attributes } = filterData;

  const saleAddHandler = (key, value, sort_by) => {
    let path;
    let checkSale;

    if (
      !activeType &&
      !classType &&
      !sort_by &&
      !levelType &&
      visualAttribute.length == 0
    ) {
      path = `${MARKET_PLACE.INDEX}?for_sale=${key}`;
    } else if (forSale) {
      Object.entries(status.for_sale).map(([k, v]) => {
        if (forSale == v) {
          checkSale = k;
        }
      });

      path = query.replace(
        `for_sale=${spacer(checkSale)}`,
        `for_sale=${spacer(key)}`
      );
    } else {
      path = `${query}&for_sale=${spacer(key)}`;
    }
    if (path.includes("sort_by=expensive") && key == "false") {
      path = path.replace(`sort_by=expensive`, `sort_by=ascending`);
    }
    if (path.includes("sort_by=cheapest") && key == "false") {
      path = path.replace(`sort_by=cheapest`, `sort_by=ascending`);
    }
    setForSale(value);
    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  const saleRemoveHandler = (key, sort_by) => {
    let path;

    if (
      !activeType &&
      !classType &&
      visualAttribute.length == 0 &&
      !levelType &&
      !sort_by
    ) {
      path = query
        .replace(`&for_sale=${spacer(key)}`, ``)
        .replace(`?for_sale=${spacer(key)}`, "");
    } else {
      path = query
        .replace(`&for_sale=${spacer(key)}`, ``)
        .replace(`?for_sale=${spacer(key)}&`, "?");
    }

    setForSale("");

    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  const handleSale = (key, value) => {
    let path;

    setTokenNumber("");
    setTokenName("");

    const { sort_by } = useQuery();

    if (value == forSale) {
      path = saleRemoveHandler(key, sort_by);
    } else {
      path = saleAddHandler(key, value, sort_by);
    }

    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }
    navigate(path);
  };

  // handle removable of type
  const typeRemoveHandler = (sort_by, type) => {
    let path;

    if (
      visualAttribute.length == 0 &&
      !classType &&
      !levelType &&
      !sort_by &&
      !forSale
    ) {
      path = query
        .replace(`&type=${spacer(type)}&`, "")
        .replace(`?type=${spacer(type)}`, "");
    } else {
      path = query
        .replace(`&type=${spacer(type)}`, ``)
        .replace(`?type=${spacer(type)}&`, "?");
    }

    setActiveType("");
    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  const checkType = (type, query) => {
    let path = query;

    setTokenNumber("");
    setTokenName("");

    if (levelType) {
      const checkLevelSelected = level?.[type]?.some(
        (item) => item == levelType
      );

      if (!checkLevelSelected) {
        path = path
          .replace(`?level=${spacer(levelType)}&`, "?")
          .replace(`&level=${spacer(levelType)}&`, "&")
          .replace(`&level=${spacer(levelType)}`, "");
        setLevelType("");
      }
    }
    //localhost:3006/api/search/1?visual=Accessory-Pistol&attribute=Gender-Malevisual

    http: if (classType) {
      const checkClassSelected = class_types?.[type]?.some(
        (item) => item == classType
      );

      if (!checkClassSelected) {
        path = path
          .replace(`?class_type=${spacer(classType)}&`, "?")
          .replace(`&class_type=${spacer(classType)}`, "");
        setClassType("");
      }
    }

    return path;
  };

  // handle Adding of type
  const typeAddHandler = (sort_by, type) => {
    let path = "";

    setActiveType(type);

    if (
      visualAttribute.length == 0 &&
      !classType &&
      !sort_by &&
      !levelType &&
      !forSale
    ) {
      path = `${MARKET_PLACE.INDEX}?type=${spacer(type)}`;
    } else if (activeType) {
      path = query.replace(`${spacer(activeType)}`, `${spacer(type)}`);
    } else {
      path = `${query}&type=${spacer(type)}`;
    }

    path = checkType(type, path);

    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  // handletype
  const handleActiveType = (type) => {
    let path;

    setTokenNumber("");
    setTokenName("");

    const { sort_by } = useQuery();

    if (activeType == type) {
      path = typeRemoveHandler(sort_by, type);
    } else {
      path = typeAddHandler(sort_by, type);
    }

    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }

    navigate(path);
  };

  //function to replace or remove visual attribute
  const visualAttributeRemoveHandler = (sort_by, attribute) => {
    let path;

    const replaceableVisualAttribute = visualAttribute.find(
      (item) => item.key == attribute.key
    );

    // when value of visual attribute don't match
    if (replaceableVisualAttribute.value != attribute.value) {
      path = query.replace(
        `attribute=${spacer(replaceableVisualAttribute.key)}-${spacer(
          replaceableVisualAttribute.value
        )}`,
        `attribute=${spacer(attribute.key)}-${spacer(attribute.value)}`
      );

      setVisualAttribute((prev) => {
        const previous = prev.filter((item) => item.key != attribute.key);

        return [...previous, attribute];
      });

      // when value match with attribute
    } else {
      // when classType,activeType,sortBy is present
      if (
        visualAttribute.length > 1 ||
        classType ||
        activeType ||
        sort_by ||
        forSale ||
        levelType
      ) {
        path = query
          .replace(
            `&attribute=${spacer(attribute.key)}-${spacer(attribute.value)}`,
            ""
          )
          .replace(
            `?attribute=${spacer(attribute.key)}-${spacer(attribute.value)}&`,
            "?"
          );
      } else {
        path = query.replace(
          `?attribute=${spacer(replaceableVisualAttribute.key)}-${spacer(
            replaceableVisualAttribute.value
          )}`,
          ``
        );
      }
      setVisualAttribute((prev) => {
        const previous = prev.filter((item) => item.value != attribute.value);

        return previous;
      });
    }

    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  //add visual attribute
  const visualAttributeAddHandler = (sort_by, attribute) => {
    let path;

    if (visualAttribute.length == 0) {
      setVisualAttribute([attribute]);
      // if any of attribute matches.
      if (activeType || classType || sort_by || forSale || levelType) {
        path = `${query}&attribute=${spacer(attribute.key)}-${spacer(
          attribute.value
        )}`;
      } else {
        path = `${MARKET_PLACE.INDEX}?attribute=${spacer(
          attribute.key
        )}-${spacer(attribute.value)}`;
      }
    } else {
      setVisualAttribute((prev) => {
        return [...prev, attribute];
      });
      // adding new visual attribute with different key and value
      if (!visualAttribute.some((element) => element.key == attribute.key)) {
        path = `${query}&attribute=${spacer(attribute.key)}-${spacer(
          attribute.value
        )}`;
      }
    }
    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  // handle Visual attribute
  const handleVisualSelection = (attribute) => {
    let path;

    setTokenNumber("");
    setTokenName("");
    logger.debug("Filter attributes", { attribute });
    const { sort_by } = useQuery();

    //when same key value match
    if (visualAttribute.some((item) => item.key == attribute.key)) {
      path = visualAttributeRemoveHandler(sort_by, attribute);
    } else {
      path = visualAttributeAddHandler(sort_by, attribute);
    }

    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }
    window.scrollTo(0, 0);
    logger.debug("Filter attributes end");

    navigate(path);
  };

  // remove or replace class from query an click
  const classRemoveHandler = (sort_by, selectedClass) => {
    let path;
    //when there is no value for activeType visual attribute

    if (
      !activeType &&
      visualAttribute.length == 0 &&
      !levelType &&
      !sort_by &&
      !forSale
    ) {
      path = query
        .replace(`&class_type=${spacer(selectedClass)}`, ``)
        .replace(`?class_type=${spacer(selectedClass)}`, "");
    } else {
      path = query
        .replace(`&class_type=${spacer(selectedClass)}`, ``)
        .replace(`?class_type=${spacer(selectedClass)}&`, "?");
    }

    setClassType("");
    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  // handle Class add on query
  const classAddHandler = (sort_by, selectedClass) => {
    let path;

    setClassType(selectedClass);

    if (
      !activeType &&
      visualAttribute.length == 0 &&
      !levelType &&
      !sort_by &&
      !forSale
    ) {
      path = `${MARKET_PLACE.INDEX}?class_type=${spacer(selectedClass)}`;
    } else if (classType) {
      path = query.replace(`${spacer(classType)}`, `${spacer(selectedClass)}`);
    } else {
      path = `${query}&class_type=${spacer(selectedClass)}`;
    }

    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };

  // remove or replace class from query an click
  const levelRemoveHandler = (sort_by, selectedLevel) => {
    let path;

    //when there is no value for activeType visual attribute
    if (
      !activeType &&
      visualAttribute.length == 0 &&
      !classType &&
      !sort_by &&
      !forSale
    ) {
      path = query
        .replace(`&level=${selectedLevel}`, ``)
        .replace(`?level=${selectedLevel}`, "");
    } else {
      path = query
        .replace(`&level=${selectedLevel}`, ``)
        .replace(`?level=${selectedLevel}&`, "?");
    }

    setLevelType("");
    dispatch(fetchMarketPlaceQuery(path));

    return path;
  };
  const spacer = (string) => {
    return string.replaceAll(" ", "%20");
  };
  // handle Class add on query
  const levelAddHandler = (sort_by, selectedLevel) => {
    let path;
    logger.debug("Level add handler", { sort_by, selectedLevel, levelType });

          logger.debug("Selected level", { selectedLevel });

    if (
      !activeType &&
      visualAttribute.length == 0 &&
      !sort_by &&
      !classType &&
      !forSale
    ) {
      logger.debug("New query created");
      path = `${MARKET_PLACE.INDEX}?level=${spacer(selectedLevel)}`;
    } else if (levelType) {
              logger.debug("Replacing query", { query });

      path = query.replace(`${spacer(levelType)}`, `${spacer(selectedLevel)}`);
    } else {
      path = `${query}&level=${spacer(selectedLevel)}`;
    }
    setLevelType(selectedLevel);

    dispatch(fetchMarketPlaceQuery(path));
    logger.debug("Level add handler end");

    return path;
  };

  //handle class section
  const handleClassSelection = (selectedClass) => {
    let path;

    setTokenNumber("");
    setTokenName("");
    const { sort_by } = useQuery();

    // when user un select the class
    if (selectedClass == classType) {
      path = classRemoveHandler(sort_by, selectedClass);
    } else {
      path = classAddHandler(sort_by, selectedClass);
    }

    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }

    window.scrollTo(0, 0);
    navigate(path);
  };

  const handleLevelSelection = (selectedLevel) => {
    let path;

    setTokenNumber("");
    setTokenName("");
    const { sort_by } = useQuery();
    logger.debug("Level remove handler", { selectedLevel, levelType });
    // when user un select the class
    if (selectedLevel == levelType) {
      path = levelRemoveHandler(sort_by, selectedLevel);
      // path = classRemoveHandler(sort_by, selectedClass);
    } else {
      path = levelAddHandler(sort_by, selectedLevel);
      // path = classAddHandler(sort_by, selectedClass);
    }

    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }

    window.scrollTo(0, 0);
    navigate(path);
  };

  const handleTokenNameSearch = (searchKeyword) => {
    setTokenNumber("");
    //checking if the given string is fully int or not
    if (!Number.isInteger(Number.parseInt(searchKeyword[0]))) {
      //searching using search token name
      if (searchKeyword.length == 0) {
        handleTokenNameClear();
        handleTokenIdClear();
      } else {
        navigate(`${MARKET_PLACE.INDEX}?token_name=${searchKeyword}`);
        dispatch(fetchMarketPlaceSearchData(1, `?token_name=${searchKeyword}`));
      }
    } else {
      //Searching using search token number
      handleTokenIdSearch(searchKeyword);
    }
  };

  const handleTokenIdSearch = (tokenNumber) => {
    setTokenName(tokenNumber);
    navigate(`${MARKET_PLACE.INDEX}?token_number=${tokenNumber}`);
    dispatch(fetchMarketPlaceSearchData(1, `?token_number=${tokenNumber}`));
  };

  const handleTokenIdClear = () => {
    setTokenNumber("");
    navigate(`${MARKET_PLACE.INDEX}`);
    dispatch(fetchMarketPlaceData(1));
  };

  const handleTokenNameClear = () => {
    setTokenName("");
    navigate(`${MARKET_PLACE.INDEX}`);
    dispatch(fetchMarketPlaceData(1));
  };

  const setQueryWithPathHandler = (query) => {
    let path = query;

    if (queryPath.class_type) {
      path = `${query}&class_type=${queryPath.class_type[0]}`;
    }
    if (queryPath.attribute) {
      queryPath.attribute.map((element) => {
        path = `${query}&attribute=${element}`;
      });
    }
    if (queryPath.sort_by) {
      path = `${query}&sort_by=${queryPath.sort_by[0]}`;
    }

    if (queryPath.for_sale) {
      path = `${query}&for_sale=${queryPath.for_sale[0]}`;
    }

    if (queryPath.level) {
      path = `${query}&for_sale=${queryPath.level[0]}`;
    }

    return path;
  };

  const setQueryNoPathHandler = () => {
    let path;

    if (queryPath.class_type) {
      path = `${MARKET_PLACE.INDEX}?class_type=${queryPath.class_type[0]}`;
    }

    if (queryPath.attribute) {
      if (path) {
        queryPath.attribute.map((element) => {
          path = `${path}&attribute=${element}`;
        });
      } else {
        queryPath.attribute.map((element) => {
          path = `${MARKET_PLACE.INDEX}?attribute=${element}`;
        });
      }
    }

    if (queryPath.sort_by) {
      if (path) {
        path = `${path}&sort_by=${queryPath.sort_by[0]}`;
      } else {
        path = `${MARKET_PLACE.INDEX}?sort_by=${queryPath.sort_by[0]}`;
      }
    }

    if (queryPath.for_sale) {
      if (path) {
        path = `${path}&for_sale=${queryPath.for_sale[0]}`;
      } else {
        path = `${MARKET_PLACE.INDEX}?for_sale=${queryPath.for_sale[0]}`;
      }
    }

    if (queryPath.level) {
      if (path) {
        path = `${path}&level=${queryPath.level[0]}`;
      } else {
        path = `${MARKET_PLACE.INDEX}?level=${queryPath.level[0]}`;
      }
    }

    return path;
  };

  // update the query state data
  const setQueries = () => {
    let path;

    if (queryPath.type) {
      path = `${MARKET_PLACE.INDEX}?type=${queryPath?.type[0]}`;
    }
    if (path) {
      path = setQueryWithPathHandler(path);
    } else {
      path = setQueryNoPathHandler();
    }

    if (queryPath.token_name) {
      setTokenName(queryPath.token_name);
      dispatch(
        fetchMarketPlaceSearchData(1, `?token_name=${queryPath.token_name}`)
      );
    } else if (queryPath.token_number) {
      setTokenNumber(queryPath.token_number);
      setTokenName(queryPath.token_number);

      dispatch(
        fetchMarketPlaceSearchData(1, `?token_number=${queryPath.token_number}`)
      );
    }

    dispatch(fetchMarketPlaceQuery(path));
  };

  // get query path data and set to states
  const getQueryPath = () => {
    const path = useQuery();

    if (path.type) {
      setActiveType(path.type[0]);
    } else {
      setActiveType("");
    }

    if (path.class_type) {
      let item = "";
      const temp = path.class_type[0];

      if (temp.search("%20")) {
        item = temp.replaceAll("%20", " ");
      } else {
        item = temp;
      }
      setClassType(item);
    } else {
      setClassType("");
    }

    if (path.attribute) {
      let temp = [];

      path.attribute.map((element) => {
        const splitElement = element.split("-");
        let item = "";

        if (splitElement[1].search("%20")) {
          item = splitElement[1].replaceAll("%20", " ");
        } else {
          item = splitElement[1];
        }

        temp.push({
          key: splitElement[0],
          value: splitElement.slice(1).join("-").replaceAll("%20", " "),
        });
      });

      setVisualAttribute(temp);
    } else {
      setVisualAttribute([]);
    }

    if (path.for_sale) {
      Object.entries(status.for_sale).map(([key, value]) => {
        if (key == path.for_sale[0]) {
          setForSale(value);
        }
      });
    } else {
      setForSale("");
    }

    if (path.level) {
      let item = "";
      const temp = path.level[0];

      if (temp.search("%20")) {
        item = temp.replaceAll("%20", " ");
      } else {
        item = temp;
      }
      setLevelType(item);
    } else {
      setLevelType("");
    }
  };

  const resetQuery = () => {
    dispatch(fetchMarketPlaceData(currentPage));
    dispatch(fetchMarketPlaceQuery(""));
    getQueryPath();
  };

  // update the gangsters bet search list.
  useEffect(() => {
    const activeQuery = useQuery();

    if (activeQuery.token_name || activeQuery.token_number) return;

    if (!query || query == MARKET_PLACE.INDEX || isEmpty(activeQuery))
      return resetQuery();

    const path = query?.replace(MARKET_PLACE.INDEX, "");

    getQueryPath();

    dispatch(fetchMarketPlaceFilterData(currentPage, path));
  }, [query]);

  useEffect(() => {
    setQueries();
    return () => {
      logger.debug("Removing path");
      dispatch(fetchMarketPlaceQuery(""));
    };
  }, []);

  const expandSVG = (showVertical = false) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        className="expand"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3332 10H6.6665"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        {showVertical ? (
          <path d="M 10,5 V15" stroke-width="1.5" stroke-linecap="round" />
        ) : null}
        <path
          d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z"
          stroke-width="1.5"
        />
      </svg>
    );
  };

  const returnIfExistIn = (item, key) => {
    logger.debug("Filter item", { item });
    return item.includes(key);
  };
  return (
    <div className={`filter ${hide && "d-none hide"}`}>
      <div className="card filter-card">
        <div className="filter-list">
          <h3 style={{ color: "var(--text-color-amt)" }}>Filter</h3>
          <div className={`search py-2 ${collapse.search && "filter-border"}`}>
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#search"
              role="button"
              aria-expanded="false"
              aria-controls="type"
              onClick={() => handleCollapse("search")}
            >
              <p className="title">Search</p>
              {expandSVG(collapse.search)}
            </div>
            <div className="collapse show" id="search">
              <div className="type-container flex-column">
                <div className="w-100">
                  <div className="my-2 w-100 position-relative">
                    <input
                      type="text"
                      className={`form-control w-100  search-input`}
                      id="price"
                      defaultValue={tokenName}
                      aria-describedby="price"
                      autocomplete="off"
                      placeholder="Search by name"
                      value={tokenName}
                      onKeyDown={(evt) => {
                        if (evt.key === "Enter") {
                          handleTokenNameSearch(tokenName);
                        }
                      }}
                      required
                      onChange={(e) => setTokenName(e.target.value)}
                    />
                    <img
                      src={ICON_PLUS.SOURCE}
                      alt="search"
                      onClick={async () => {
                        handleTokenNameClear();
                      }}
                      className={`plus-icon position-absolute ${tokenName.length >= 1 ? `active` : ""
                        }`}
                    />
                    <img
                      src={SEARCH_ICON.SOURCE}
                      alt="search"
                      className="search-icon position-absolute"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`sale py-2 ${collapse.sale && "filter-border"}`}>
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#sale"
              role="button"
              aria-expanded="false"
              aria-controls="sale"
              onClick={() => handleCollapse("sale")}
            >
              <p className="title">Sale</p>
              {expandSVG(collapse.sale)}
            </div>
            <div className="collapse show" id="sale">
              <div className="type-container pe-4">
                {Object.entries(status.for_sale).map(([key, value], index) => (
                  <FilterItem
                    value={value}
                    index={index}
                    active={forSale == value ? true : false}
                    onClickHandler={() => {
                      handleSale(key, value);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className={`type py-2 ${collapse.type && "filter-border"}`}>
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#type"
              role="button"
              aria-expanded="false"
              aria-controls="type"
              onClick={() => handleCollapse("type")}
            >
              <p className="title">Type</p>
              {expandSVG(collapse.type)}
            </div>
            <div className="collapse show" id="type">
              <div className="type-container pe-4">
                {types?.map((item, index) => (
                  <FilterItem
                    value={item}
                    index={index}
                    active={activeType == item ? true : false}
                    onClickHandler={() => {
                      handleActiveType(item);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className={`level py-2 ${collapse.level && "filter-border"}`}>
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#level"
              role="button"
              aria-expanded="false"
              aria-controls="type"
              onClick={() => handleCollapse("level")}
            >
              <p className="title">Level </p>
              {expandSVG(collapse.level)}
            </div>
            <div className="collapse show" id="level">
              <div>
                {activeType
                  ? level?.[activeType].map((item, index) => (
                    <FilterItem
                      value={item.replace("Detective", "")}
                      index={index}
                      active={levelType == item ? true : false}
                      onClickHandler={() => {
                        handleLevelSelection(item);
                      }}
                    />
                  ))
                  : types.map((item, idx) => (
                    <>
                      <div
                        className={`sub-section ${idx != 0 ? "mt-3" : null}`}
                      >
                        <p className="mb-2" style={{ color: "var(--filter-topic)" }}>
                          <span>{item}</span>
                        </p>
                        {level[item].map((skill, index) => (
                          <FilterItem
                            value={skill.replace("Detective", "")}
                            index={index}
                            active={skill == levelType ? true : false}
                            onClickHandler={() => {
                              handleLevelSelection(skill);
                            }}
                          />
                        ))}
                      </div>
                    </>
                  ))}
              </div>
            </div>
          </div>

          <div className={`class py-2 ${collapse.class && "filter-border"}`}>
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#class"
              role="button"
              aria-expanded="false"
              aria-controls="type"
              onClick={() => handleCollapse("class")}
            >
              <p className="title">Class</p>
              {expandSVG(collapse.class)}
            </div>
            <div className="collapse show" id="class">
              <div className="d-flex flex-wrap">
                {activeType
                  ? class_types[activeType].map((item, index) => (
                    <SecondaryButton
                      className={
                        item == classType
                          ? `${item.toLowerCase()} active`
                          : item.toLowerCase()
                      }
                      key={index}
                      onClick={() => handleClassSelection(item)}
                    >
                      {item}
                    </SecondaryButton>
                  ))
                  : types.map((item, idx) => (
                    <>
                      <div
                        className={`sub-section ${idx != 0 ? "mt-3" : null}`}
                      >
                        <p style={{ color: "var(--filter-topic)" }}>
                          <span>{item}</span>
                        </p>
                        {class_types[types[idx]].map((classItem, index) => (
                          <SecondaryButton
                            className={
                              classItem == classType
                                ? "active"
                                : classItem.toLowerCase()
                            }
                            key={index}
                            onClick={() => handleClassSelection(classItem)}
                          >
                            {classItem}
                          </SecondaryButton>
                        ))}
                      </div>
                    </>
                  ))}
              </div>
            </div>
          </div>
          <div
            className={`visual-attribute py-2 ${collapse.vAttributes && "filter-border"
              }`}
          >
            <div
              className="filter-head d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              href="#visualAttribute"
              role="button"
              aria-expanded="false"
              aria-controls="type"
              onClick={() => handleCollapse("visual-attribute")}
            >
              <p className="title mb-2">Visual Attribute</p>
              {expandSVG(collapse.vAttributes)}
            </div>
            <div className="collapse show" id="visualAttribute">
              {attributes.map((item, index) =>
                Object.entries(item).map(([key, value], idx) => (
                  <>
                    <div
                      id={`${key.toLowerCase()}`}
                      className={`sub-section ${index != 0 ? "mt-3" : null}`}
                      key={key + index}
                    >
                      <p className={` text-dark mb-2`}>
                        <span>{key.replaceAll("_", " ")}</span>
                      </p>
                      {value.map((subItem, index) => (
                        <FilterItem
                          value={subItem}
                          index={index}
                          active={
                            visualAttribute.some((element) => {
                              if (
                                element.value == subItem &&
                                element.key == key.replaceAll("_", "%20")
                              ) {
                                return true;
                              } else {
                                return false;
                              }
                            })
                              ? true
                              : false
                          }
                          onClickHandler={() =>
                            handleVisualSelection({
                              key: key.replaceAll("_", "%20"),
                              value: subItem.replaceAll("_", "%20"),
                            })
                          }
                        />
                      ))}
                    </div>
                    {value.length > 6 ? (
                      <div
                        onClick={(e) => {
                          if (
                            !document
                              .getElementById(key.toLowerCase())
                              ?.classList.value.includes("full")
                          ) {
                            document.getElementById(
                              `${key.toLowerCase()}-showText`
                            ).innerText = "Show less";
                          } else {
                            document.getElementById(
                              `${key.toLowerCase()}-showText`
                            ).innerText = "Show more";
                          }
                          document
                            .getElementById(key.toLowerCase())
                            .classList.toggle("full");
                        }}
                        className={`sub-section-show-more ${key.toLowerCase()}`}
                      >
                        <div className="side-line"></div>
                        <div
                          className="text"
                          id={`${key.toLowerCase()}-showText`}
                        >
                          Show more
                        </div>
                        <div className="side-line"></div>
                      </div>
                    ) : null}
                  </>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
